export const INCREMENT = "INCREMENT"
export const DECREMENT = "DECREMENT"
export const TABLEDATA = "TABLEDATA"


// WEBPACK FOOTER //
// ./src/store/example/types.js